import { createContext, type Dispatch, type SetStateAction, useContext } from 'react';

export interface NavbarMenuBurgerContext {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export const NavbarMenuBurgerContext = createContext<NavbarMenuBurgerContext>({
  isOpen: false,
  setIsOpen: () => {},
});

export function useNavbarMenuBurgerContext() {
  const context = useContext(NavbarMenuBurgerContext);

  if (!context) {
    throw new Error('useNavbarMenuBurgerContext must be used within a NavbarMenuBurger');
  }

  return context;
}
